import React from 'react'

type Props = {
    entity?: string
}

const AccessDenied = (props: Props) => {
    return (
        <div className="container-fluid vh-100 d-flex justify-content-center align-items-center">
            <div className="card text-center shadow" style={{ maxWidth: "400px" }}>
                <div className="card-body">
                    <h2 className="card-title text-danger">Access Denied</h2>
                    <p className="card-text">You don't have permission to view this {`${props.entity ? props.entity : "page"}`}.</p>
                </div>
            </div>
        </div>
    )
}

export default AccessDenied;